/* Core & libraries */
import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {useNavigate} from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import {useGenericApiFetch} from "../endpoints/base";
import {
  REDEMPTION_HISTORY_DOWNLOAD_ENDPOINT,
  REDEMPTION_HISTORY_COUNT_ENDPOINT,
  REDEMPTION_HISTORY_ENDPOINT,
} from "../endpoints/endpoints";
import {useNotificationContext} from "../contexts/notificationContext";
import {useUserContext} from "../contexts/userContext";
import {filtersMap} from "helpers/filtersMap";
import csvDownload from "json-to-csv-export";


/* Components */
/* Styles */

export const useRedemptionHistoryService = (props = {}) => {
  const {gridOptions = {}} = props;
  //TODO: Remove mock data
  const [redemptionHistoryResponse, setRedemptionHistoryResponse] = useState({});
  const [redemptionHistoryCountResponse, setRedemptionHistoryCountResponse] = useState({});

  const {genericApiFetch} = useGenericApiFetch();
  const {setNotification} = useNotificationContext();
  const navigate = useNavigate();
  const userDetails = useUserContext();
  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId

  useEffect(() => {
    (async () => {
      await Promise.all([getRedemptionHistoryList(gridOptions), getRedemptionHistoryCount()]);
    })();
  }, [gridOptions]);

  const getRedemptionHistoryList = async ({type = gridOptions.type, ...options} = gridOptions) => {
    options = filtersMap(options);

    const response = await genericApiFetch({
      url: REDEMPTION_HISTORY_ENDPOINT.replace("{companyEntityId}", companyEntityId).replace("{status}", type.toUpperCase()),
      method: "GET",
      queryParams: options,
      spinner: "redemptionHistoryGridSpinner"
    });
    if (response.success) {
      setRedemptionHistoryResponse(response.data);
    } else {
      setRedemptionHistoryResponse({ results: null });
    }
  };

  const handleDownloadReport = async ({type = gridOptions.type, page, ...options} = gridOptions) => {
    options = filtersMap(options);

    const response = await genericApiFetch({
      url: REDEMPTION_HISTORY_DOWNLOAD_ENDPOINT.replace("{companyEntityId}", companyEntityId).replace("{status}", type.toUpperCase()),
      method: "GET",
      queryParams: options,
      spinner: "redemptionHistoryDownloadSpinner"
    });

    if (response.success) {
      csvDownload({
        data: response.data.items,
        filename: response.data.fileName,
        delimiter: ",",
        fileType: "text/csv"
      });
      return true
    } else {
      setNotification(
        "error",
        <FormattedMessage id="notifications.reportErrorTitle" />,
        <FormattedMessage id="notifications.reportErrorText" />
      )
      return false
    }
  };

  const getRedemptionHistoryCount = async () => {
    const failedCountResponse = await genericApiFetch({
      url: REDEMPTION_HISTORY_COUNT_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "GET",
      // spinner: "redemptionHistoryGridSpinner"
    });

    if (failedCountResponse.success) {
      setRedemptionHistoryCountResponse(failedCountResponse.data);
    } else {
      setRedemptionHistoryCountResponse({});
    }
  }

  return {
    redemptionHistoryCountResponse,
    redemptionHistoryResponse,
    getRedemptionHistoryList,
    getRedemptionHistoryCount,
    handleDownloadReport
  };
}